// extracted by mini-css-extract-plugin
module.exports = {"costcoBtn":"costcoOverRide_costcoBtn__3PdiV"};